<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Logout',
  methods: {
    ...mapActions('auth', ['authLogout'])
  },
  mounted() {
    this.authLogout()
  }
}
</script>